module.exports = __webpack_public_path__ + "img/special_05.3f6a0d5d.png";